export default [
  {
    path: '/pledge-2023/index',
    name: 'index',
    component: () => import('@/views/pledge-2023'),
    meta: {
      title: '2023高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2023/pledgepersonal',
    name: 'pledgepersonal',
    component: () => import('@/views/pledge-2023/pledgepersonal'),
    meta: {
      title: '2023高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2023/pledgelist',
    name: 'pledgelist',
    component: () => import('@/views/pledge-2023/pledgelist'),
    meta: {
      title: '2023高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2023/pledgeform',
    name: 'pledgeform',
    component: () => import('@/views/pledge-2023/pledgeform'),
    meta: {
      title: '2023高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2023/pledgeupload',
    name: 'pledgeupload',
    component: () => import('@/views/pledge-2023/pledgeupload'),
    meta: {
      title: '2023高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2023/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge-2023/blessing'),
    meta: {
      title: '写下你的誓词，赢超值大礼！'
    }
  },
  {
    path: '/pledge-2023/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge-2023/myblessing'),
    meta: {
      title: '写下你的誓词，赢超值大礼！'
    }
},
  {
    path: '/pledge-2023/mypledge',
    name: 'mypledge',
    component: () => import('@/views/pledge-2023/mypledge'),
    meta: {
      title: '写下你的誓词，赢超值大礼！'
    }
  },{
    path: '/pledge-2023/pledgeinfo',
    name: 'pledgeinfo',
    component: () => import('@/views/pledge-2023/pledgeinfo'),
    meta: {
      title: '2023高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2023/blessing',
    name: 'blessing',
    component: () => import('@/views/pledge-2023/blessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2023高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge-2023/myblessing',
    name: 'myblessing',
    component: () => import('@/views/pledge-2023/myblessing'),
    meta: {
      title: '送出你的学霸寄语，为参加2023高考的学弟学妹们加油助威！'
    }
  },
  {
    path: '/pledge-2023/lotteryRecord',
    name: 'lotteryRecord',
    component: () => import('@/views/pledge-2023/lotteryRecord'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  },
  {
    path: '/pledge-2023/lottery',
    name: 'lottery',
    component: () => import('@/views/pledge-2023/lottery'),
    meta: {
      title: '写下你的誓词，赢超级大利！'
    }
  }
]
